import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  link: {
    display: 'inherit',
  },
  linkImage: {
    height: 35,
    width: 'auto',

    '&:hover': {
      opacity: 0.3,
    },
  },
});

const VirtualOrderPdfCellRenderer = withStyles(styles)(({ data, classes, ...rest }) => {
  // catch in case the grid is infinite loading and loads blank rows
  if (!data) {
    return;
  }

  return (
    <div className={classes.container}>
      <a
        className={classes.link}
        href={data.childOrderLocation || data.location}
        onClick={evt => {
          !data.location && evt.preventDefault();
          evt.stopPropagation();
        }}
      >
        <img
          className={classes.linkImage}
          src={!!data.location || !!data.childOrderLocation ? '/assets/images/report_icon_25x25.png' : '/assets/images/report_unavailable_25x25.png'}
        />
      </a>
    </div>
  );
});

VirtualOrderPdfCellRenderer.propTypes = {
  classes: PropTypes.object,
  gridData: PropTypes.array,
  onSave: PropTypes.func,
};

export default VirtualOrderPdfCellRenderer;
